import { render, staticRenderFns } from "./ListaGestionesTelefonicasPersona.vue?vue&type=template&id=5cf7fe8c"
import script from "./ListaGestionesTelefonicasPersona.vue?vue&type=script&lang=js"
export * from "./ListaGestionesTelefonicasPersona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports